// src/components/AdBanner.tsx

import { useEffect, useRef } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { getPlanFeatures } from '@/lib/planFeatures';

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

interface AdBannerProps {
  slot: string;  // AdSense広告ユニットID
  format?: 'auto' | 'fluid' | 'rectangle' | 'horizontal' | 'vertical';
  layout?: string;
  className?: string;
}

export function AdBanner({ 
  slot, 
  format = 'auto', 
  layout,
  className = '' 
}: AdBannerProps) {
  const { user } = useAuth();
  const adRef = useRef<HTMLModElement>(null);
  const isLoaded = useRef(false);

  const features = getPlanFeatures(user);

  useEffect(() => {
    // Standardプランは広告非表示
    if (!features.showAds) return;

    // 既に読み込み済みの場合はスキップ
    if (isLoaded.current) return;

    try {
      if (adRef.current && window.adsbygoogle) {
        window.adsbygoogle.push({});
        isLoaded.current = true;
      }
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, [features.showAds]);

  // Standardプランは広告を表示しない
  if (!features.showAds) {
    return null;
  }

  return (
    <div className={`ad-container ${className}`}>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-XXXXXXXXXXXXXXXX"  // ← あなたのAdSense Publisher ID
        data-ad-slot={slot}
        data-ad-format={format}
        data-ad-layout={layout}
        data-full-width-responsive="true"
      />
    </div>
  );
}

/**
 * サイドバー下部用の広告
 */
export function SidebarAd() {
  return (
    <AdBanner
      slot="XXXXXXXXXX"  // ← 広告ユニットID
      format="vertical"
      className="mt-6"
    />
  );
}

/**
 * コンテンツ下部用の広告
 */
export function ContentBottomAd() {
  return (
    <AdBanner
      slot="XXXXXXXXXX"  // ← 広告ユニットID
      format="horizontal"
      className="mt-8 mb-4"
    />
  );
}

/**
 * レスポンシブ広告（ページ間）
 */
export function ResponsiveAd() {
  return (
    <AdBanner
      slot="XXXXXXXXXX"  // ← 広告ユニットID
      format="auto"
      className="my-6"
    />
  );
}
